module.exports = __webpack_public_path__ + "static/img/fr03.6e429c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/fr03.png
// module id = RDkM
// module chunks = 18